import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { CreditCardPaymentService } from '../shared/services/creditCardPayment.service';
import { Validators } from 'src/app/shared/validators';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { FormControl, FormGroup } from '@angular/forms';
import { CancelCreditPaymentService } from 'src/app/public-website/buyer/services/cancel-credit-payment.service';
import { PAYMENTATTEMPT_STATUS } from 'src/app/shared/paymentStatuses';
import { TranslateService } from '@ngx-translate/core';
import { CreditCardPay } from 'src/app/public-website/buyer/services/creditCardPay.service';
import {
  billtrxPaymentParams,
  trxInquiryResponse,
} from '../interfaces/trxresult.interface';
import { InquireTransactionService } from '../shared/services/InquireTransaction.service';
import { isInquirableService } from '../shared/services/isInquirable.service';
import { prepareNonInquireTransaction } from '../shared/services/prepareNonInquireTransaction.service';
import { GetIpService } from 'src/app/public-website/buyer/services/get-ip-address.service';
import { PaymentInquiryService } from 'src/app/shared/services/payment-inquiry.service';
@Component({
  selector: 'app-credit-card-pay',
  templateUrl: './credit-card-pay.component.html',
  styleUrls: ['./credit-card-pay.component.scss'],
})
export class CreditCardPayComponent implements OnInit {
  formValidator = new FormValidatorService();
  selectedInstallmentPlan: string;
  installmentPlans: string[];
  creditCardForm!: FormGroup;
  interval: any; // unable to determine its type
  isInstallments: boolean = false;
  cardErrors: string = '';
  submitted = false;


  installmentPlansMapping = {
    '6 Months - NBE': '6',
    '12 Months - NBE': '12',
    '18 Months - NBE': '18',
  };

  creditCardFields = {
    creditCardNumber: {
      fieldName: 'Number',
      fieldType: 'tel',
      autoCompleteName: 'cc-number',
      validators: [
        {
          validatorFn: Validators.required,
          message: '',
        },
        {
          validatorFn: Validators.minLength(16),
          message: '',
        },
        {
          validatorFn: Validators.maxLength(19),
          message: '',
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0-9\s]*$/),
          message: '',
        },
      ],
      defaultValue: '',
    },
    expirationMonthAndYear: {
      fieldName: 'expiration',
      fieldType: 'tel',
      autoCompleteName: 'cc-exp',
      validators: [
        {
          validatorFn: Validators.required,
          message: '',
        },
        {
          validatorFn: CustomValidators.customPattern(/(\d\d)\s*\/\s*(\d\d)/),
          message: '',
        },
      ],
      defaultValue: '',
    },
    securityCode: {
      fieldName: 'CVV',
      fieldType: 'tel',
      autoCompleteName: 'cc-csc',
      validators: [
        {
          validatorFn: Validators.required,
          message: '',
        },
        {
          validatorFn: Validators.maxLength(4),
          message: '',
        },
        {
          validatorFn: Validators.minLength(3),
          message: '',
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0-9\s]*$/),
          message: '',
        },
      ],
      defaultValue: '',
    },
    cardType: {
      fieldName: 'cardType',
      defaultValue: '',
    },
  };
  openOtp: boolean = false;
  otpReqObj: IDirectPayResponse;
  authenticateObj: IDirectAuthenticateResponse;
  billAmount: number;
  isInquirable: boolean;
  constructor(
    public creditCardService: CreditCardPaymentService,
    public creditCardPay: CreditCardPay,
    private router: Router,
    private cancelCreditPaymentService: CancelCreditPaymentService,
    private translate: TranslateService,
    private inquireTransaction: InquireTransactionService,
    private isInquirableService: isInquirableService,
    private nonInquirableService: prepareNonInquireTransaction,
    private getIpService : GetIpService,
    private paymentInquire: PaymentInquiryService,
  ) {}

  async ngOnInit(): Promise<void> {
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.creditCardForm = this.formValidator.createForm(
      Object.values(this.creditCardFields)
    );
    this.isInquirableService.isinquirableState.subscribe((res) => {
      this.isInquirable = res;
    });
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
    this.isInstallments = this.creditCardService.providerObject?.isInstallment;
    this.installmentPlans =
      this.creditCardService.providerObject?.installmentPlans;
    await this.makePageExpired();
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        creditCardNumber: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Credit card number',
            fieldAr: 'رقم بطاقه الائتمان',
          }),
          customPattern: this.translate.instant(
            'FormValidation.RequiredNumber',
            {
              field: 'Credit card number',
              fieldAr: 'رقم بطاقه الائتمان',
            }
          ),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Credit card number',
            fieldAr: 'رقم بطاقه الائتمان',
            value: 16,
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Credit card number',
            fieldAr: 'رقم بطاقه الائتمان',
            value: 19,
          }),
        },
        expirationMonthAndYear: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Expiration',
            fieldAr: 'انتهاء الصلاحية',
          }),
          customPattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Expiration',
            fieldAr: 'انتهاء الصلاحية',
          }),
        },
        securityCode: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'CVV',
            fieldAr: 'CVV',
          }),
          customPattern: this.translate.instant(
            'FormValidation.RequiredNumber',
            {
              field: 'CVV',
              fieldAr: 'CVV',
            }
          ),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'CVV',
            fieldAr: 'CVV',
            value: 3,
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'CVV',
            fieldAr: 'CVV',
            value: 4,
          }),
        },
      };
    });
  }

  /**
   * this is the start of the form handling format and submit
   */

  convertPaymentControl(name: string): FormControl {
    return this.creditCardForm.controls[name] as FormControl;
  }

  async setCreditCardParams(payObject, trxInquiryResponse: trxInquiryResponse) {
    const billPaymentParams: billtrxPaymentParams = this.isInquirable
      ? {
          amount: trxInquiryResponse.data.amount,
          customerReference: trxInquiryResponse.RefNum,
        }
      : {
          amount: +this.nonInquirableService.nonInqtrxResponse.amount,
          customerReference: this.nonInquirableService.nonInqtrxResponse.RefNum,
          billerService : this.nonInquirableService.nonInqtrxResponse.billerService
        };
    this.creditCardService.setPayToken(payObject, billPaymentParams);
  }
  async submit(): Promise<void> {
    // set the creditcardobject
    let payObject: ICreditPayReq = {
      number: this.creditCardForm.controls['Number'].value,
      'security-code': this.creditCardForm.controls['CVV'].value,
      'expiration-month-and-year':
        this.creditCardForm.controls['expiration'].value,
    };
    this.setCreditCardParams(
      payObject,
      this.inquireTransaction.trxInquiryResponse
    );
    this.authenticateObj = await this.creditCardService.make();
    if(!this.authenticateObj?.success){
      this.cardErrors =
      this.authenticateObj.message == 'InvalidCardNumber'
        ? 'Buyer.InvalidCardNumber'
        : 'Buyer.authenticationIssue';
        return;
    }
    this.authenticateObj.orderData.browser = window.navigator.userAgent;
    let ip = null;
    try{
      ip = (await this.getIpService.make()).ip
    }catch(e){
      console.log(e);
    }
    this.authenticateObj.orderData.ipAddress = ip;

    //authentication step
    if(this.authenticateObj.success){
      await this.providerInfoGathering();
      this.creditCardPay.setParams({...this.authenticateObj.orderData,token:this.creditCardService.encToken})
      this.otpReqObj = await this.creditCardPay.make();
    }else this.cardErrors ="Buyer.authenticationIssue"
        console.log("this.otpReqObj.redirectUrl ",  this.otpReqObj.redirectUrl)
        console.log("this.otpReqObj.success ", this.otpReqObj.success)
        if (this.otpReqObj.redirectUrl && this.otpReqObj.success) {
          //rendersuccess
          this.showOtp()
        } else if (this.otpReqObj.message && !this.otpReqObj.success) {
          //card issues
          if (this.otpReqObj.message == 'cardInvalid') {
            this.cardErrors = 'Buyer.CardInvalid';
          } else if (this.otpReqObj.message == 'providerError') {
            this.cardErrors = 'Buyer.ProviderError';
          } else if (this.otpReqObj.message == 'InvalidCardNumber') {
            this.cardErrors = 'Buyer.InvalidCardNumber';
          }else {
            this.cardErrors = 'Buyer.UnknownCardError';
          }
        } else if (this.otpReqObj.success && !this.otpReqObj.redirectUrl) {
          //redirect success none 3DSecure
          await this.onCallBack(PAYMENTATTEMPT_STATUS.PAID);
        } else if (!this.otpReqObj.success) {
          //redirect failure none 3DSecure
          await this.onCallBack(PAYMENTATTEMPT_STATUS.FAILED);
        }


  }

  //cancel credit card payment
  async cancelPayment(status: string): Promise<void> {
    try {
      this.cancelCreditPaymentService.setParams({
        refNum: this.creditCardService.trxRefNum,
        status,
        merchant_ref_num: this.creditCardService.merchant_ref_num,
      });
      await this.cancelCreditPaymentService.make();
    } catch (error) {
      console.log('cancel payment error: ', error);
    }
  }
  back(): void {
    this.router.navigate(['/seller/billPayments']);
  }
  //expire the page after one hour
  async makePageExpired(): Promise<void> {
    await this.sleep(1000 * 60 * 60);
    await this.onCallBack(PAYMENTATTEMPT_STATUS.EXPIRED);
  }
  async sleep(ms: any): Promise<Function> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  getRefTrx() {
    return this.isInquirable ? this.inquireTransaction.trxInquiryResponse.RefNum : this.nonInquirableService.nonInqtrxResponse.RefNum
  }

  async inquireForRefund(): Promise<InquirePayment | null>{
    try{
      const wait = (repeatFlag, ms): Promise<number> =>
      new Promise((resolve, reject) => {
        setTimeout(()=> resolve(repeatFlag), ms);
      });

      console.log("inquireForRefund -> this.creditCardService -> ", this.creditCardService.getParams())
      console.log("inquireForRefund ->  this.creditCardService.trxRefNum -> ",  this.creditCardService.trxRefNum);
      console.log("inquireForRefund ->  getRefTrx -> ",  this.getRefTrx());

      this.paymentInquire.setParams({
        refNum: this.getRefTrx(), productType: ""
      });

        // 15 sec
        const delayTime = 15000;
        let repeatFlag = 2;
        let trxInquireResponse;

        do {
          trxInquireResponse = await this.paymentInquire.make();
          repeatFlag = trxInquireResponse?.data.status === 'PAID' ? 0 : await wait(--repeatFlag, delayTime);
        }
        while(repeatFlag > 0)

        trxInquireResponse.data.customerReference  = this.creditCardService.trxRefNum;
        console.log("this.creditCardService.trxRefNum ");
        return trxInquireResponse.data
    }catch(e){
      return null;
    }
  }


  //onCallBack
  async onCallBack(response: string): Promise<void> {
    console.log('++++++++++++++++++++');
    console.log('response = ', response);
    console.log(
      'inquireForRefund -> this.creditCardService -> ',
      this.creditCardService.getParams()
    );
    console.log(
      'inquireForRefund ->  this.creditCardService.trxRefNum -> ',
      this.creditCardService.trxRefNum
    );
    console.log('inquireForRefund ->  getRefTrx -> ', this.getRefTrx());
    console.log('++++++++++++++++++++');
    switch (response) {
      case PAYMENTATTEMPT_STATUS.CANCELED:
        await this.cancelPayment(response);
        break;
      case PAYMENTATTEMPT_STATUS.PAID:
        await this.inquireForRefund()
        this.handleCloseOrExpire(response);
        break;
      case PAYMENTATTEMPT_STATUS.EXPIRED:
        await this.cancelPayment(response);
        this.handleCloseOrExpire(response);
        break;
      case PAYMENTATTEMPT_STATUS.FAILED:
        this.onErrorCallback(response);
        break;
      default:
        this.handleCloseOrExpire('Unknown');
    }
  }
  //handlecall back
  handleCloseOrExpire(reason: string): void {
    this.router.navigate(['gate'], {
      queryParams: {
        refNum: this.creditCardService.trxRefNum,
        reason: reason,
      },
    });
  }
  onErrorCallback(reason: string): void {
    this.router.navigate(['gate'], {
      queryParams: {
        refNum: this.creditCardService.trxRefNum,
        reason: reason,
        card: 1,
      },
    });
  }

  calculateMonthlyInstallmentAmount(plan: string): string {
    let numberOfMonths: number = +this.installmentPlansMapping[plan];
    let amount: number = this.creditCardService.providerObject.amount;
    if (this.translate.currentLang == 'en') {
      return (amount / numberOfMonths).toFixed(2) + '/month';
    } else {
      return (amount / numberOfMonths).toFixed(2) + '/شهر';
    }
  }

  async providerInfoGathering() {
    document.getElementById('providerExtraInfoGathering').innerHTML =
      this.authenticateObj.html;
    eval(document.getElementById('initiate-authentication-script').innerText);
  }
  showOtp() {
    this.creditCardService.otpPage = this.otpReqObj.html
    this.openOtp = true;
  }
}

interface IDirectPayResponse {
  redirectUrl: string;
  html: string;
  message?: string;
  success: boolean;
}
interface IDirectAuthenticateResponse {
  message: string;
  html: string;
  orderData: {
    orderId: string;
    trxRef: string;
    browser?: string;
    ipAddress?: string;
  };
  success: boolean;
}
export interface ICreditPayReq {
  'expiration-month-and-year': string;
  number: string;
  'security-code': string; //cvv
}

export interface InquirePayment {
  status?: "PAID" | string;
  easykashStatus?: string;
  billerSystemStatus?: string;
  phone?: string;
  billerSystemAmount?: number;
  amount?: string;
  serviceFee?: string;
  discount?: string;
  totalAmount?: string;
  customerReference?: number;
  serviceName?: string;
  failureReason: string | null;
}
